import RevolverInit from "slotworks/integration/revolver/states/revolver-init";
import Components from "slotworks/components/components";
import EmptyLinesComponent from "components/lines/lines-component";
import slotDefinition from "slotworks/model/slot-definition";
import Layers from "slotworks/graphics/layers/layers";
import betModel from "slotworks/model/bets/bet-model";
import currency from "slotworks/i18n/currency";
import translations from "slotworks/i18n/translations";
import PagingPaytableComponent from "components/paytable/paytable-component";
import canvasManager, { Orientation } from "slotworks/graphics/canvas/canvas-manager";
import deviceInfo from "slotworks/utils/device-info";
import gameState from "slotworks/model/game-state";
import SpinRecord from "slotworks/model/gameplay/records/spin-record";
import G288Components from "components/components";
import LowToHighSymbolBehaviour from "components/matrix/symbols/low-to-high-symbol-behaviour";
import G288SpinReelTransition from "components/matrix/transitions/spin-reel-transition";
import FrameOverSymbolBehaviour from "components/matrix/symbols/frame-over-symbol-behaviour";
import settingsModel, { Jurisdiction } from "slotworks/model/settings/settings-model";
import Point from "slotworks/utils/geom/point";
import AnticipateSymbolBehaviour from "components/matrix/symbols/anticipate-symbol-behaviour";
import MessagesComponent from "components/messages/messages-component";
import autoplayModel from "slotworks/model/autoplay-model";
import { GlowFilter } from "pixi-filters";

declare const __VERSION__: string;
export default class G288Init extends RevolverInit {
        
    protected portraitScale: number = 1.43;
    protected gameAnchor: Point = new Point(0.48, 0);

    public onEnter() {
        const ratio = deviceInfo.getRatio();
        if(ratio > 3.5/4) {
            this.portraitScale = 1.20;
        } else if(ratio >= 2.8/4) {
            this.portraitScale = 1.35;
        }
        if(settingsModel.language == "zh-Hans") {
            document.documentElement.classList.toggle("zhHans", true);
        }
        super.onEnter();
    }

    public complete() {
        Components.lines = new EmptyLinesComponent(slotDefinition.lineDefinitions);

        Layers.PaytableContent.onSceneEnter.add((scene: string) => {
            const betText = Layers.PaytableContent.getFlexiText('bet_text');
            if(betText)
            {
                let betOptions = betModel.generateBetOptions();
                const minBet = currency.format(betOptions.coinSizes[0] * betOptions.stakePerLineValues[0] * betOptions.lines);
                const maxBet = currency.format(betOptions.coinSizes.slice(-1)[0] * betOptions.stakePerLineValues.slice(-1)[0] * betOptions.lines);
                const minBetTranslation = translations.get('min_bet');
                const maxBetTranslation = translations.get('max_bet');
                let text = `${minBetTranslation} <orange>${minBet}</orange> | ${maxBetTranslation} <orange>${maxBet}</orange>`;
                betText.setText(text);
            }
            if(scene == "page_4") {
                const title = Layers.PaytableContent.getSprite("288_title_freespins")
                const cntitle = Layers.PaytableContent.getSprite("288_title_freespins_chinese");
                if(settingsModel.language == "zh-Hans") {
                    if(title) title.visible = false;
                } else {
                    if(cntitle) cntitle.visible = false;
                }
            }
        });

        Components.paytable = new PagingPaytableComponent(Layers.PaytableContent, Layers.MenusContent, "paytable");
        Components.paytable.init(betModel.generateBetOptions());

        const drawMatrixMask = () => {
            const mask = Layers.MatrixContent.container.mask as PIXI.Graphics || new PIXI.Graphics();
            mask.clear();
            for(let i = 1; i <= 3; i++) {
                const border = Layers.MatrixContent.getPosition("mask" + i);
                mask.beginFill(0xff0000);
                mask.drawRect(border.x + canvasManager.stageOffsetX + Layers.MatrixContent.container.x, 
                    border.y + canvasManager.stageOffsetY + Layers.MatrixContent.container.y, 
                    border.width, border.height);
            }

            Layers.MatrixContent.container.mask = mask;
        }
        drawMatrixMask();
        (Components.matrix as any).drawMask = drawMatrixMask;
        if(!deviceInfo.isDesktop) {
            canvasManager.onOrientationChange.add(() => setTimeout(drawMatrixMask, 1));
        }

        G288Components.anticipation.initAnticipations();
        G288Components.stackArrows.init();

        if (settingsModel.getShowIntro()) {
            const setPortraitTexts = () => {
                if(canvasManager.orientation == Orientation.PORTRAIT && 
                    ["ru", "lv", "tr", "vi"].indexOf(settingsModel.language) > -1) {
                    for(let i = 1; i <= 3; i++) {
                        const scatterText = Layers.Prompts.getFlexiText("intro_portrait_scatter" + i);
                        if(scatterText) {
                            const scatterTranslation = translations.get("intro_feature_3_portrait_pt" + i);
                            scatterText.setText(scatterTranslation);
                        }
                    }
                    if(settingsModel.language == "ru" || settingsModel.language == "lv") {
                        const scatterText = Layers.Prompts.getFlexiText("intro_portrait_scatter" + 4);
                        if(scatterText) {
                            const scatterTranslation = translations.get("intro_feature_3_portrait_pt" + 4);
                            scatterText.setText(scatterTranslation);
                        }
                    }
                    if(settingsModel.language == "ru") {
                        const text = document.getElementById("ways_text") as HTMLDivElement;
                        if(text) {
                            text.style.fontSize = "5.3vw";
                        }
                    }
                }
            }
            // to upper case but keep formatting
            Layers.Prompts.onSceneEnter.addOnce((scene: string) => {
                if(scene == "gameintro") {
                    const nextTime = Layers.Prompts.getText("ss.dsa");
                    const text = translations.get("dont_show_next_time");
                    if(nextTime) {
                        if(translations.formats["ss.dsa"])                               
                            nextTime.text = "<ss.dsa>" + text.toUpperCase() + "</ss.dsa>";                                
                        else
                        nextTime.text = text.toUpperCase();
                    }
                    if(!deviceInfo.isDesktop) {
                        setPortraitTexts();
                        canvasManager.onOrientationChange.add(setPortraitTexts);
                    }
                }
            });
            if(!deviceInfo.isDesktop) {                
                Layers.Prompts.onSceneExit.addOnce((scene: string) => {
                    if(scene == "gameintro") {
                        canvasManager.onOrientationChange.remove(setPortraitTexts);
                    }
                });
            }
        }

        Layers.BetBar.onSceneEnter.add((scene: string) => {
            if(scene === "freespins") {
                const value = Layers.BetBar.getText("freespins_x_of_y_value");
                if(value) {
                    value.filters = [ new GlowFilter(2, 3, 0, 0xff0000)];
                }
            }
        });

        super.complete();
        
        Layers.Footer.moveBehind(Layers.MatrixForeground);
        Components.footer = new MessagesComponent();

        Layers.MenusContent.onSceneEnter.add(() => {
            const rulesText = Layers.MenusContent.getFlexiText("rules_body");
            const rtp = settingsModel.rtp;
            if (rulesText) {
                if(settingsModel.isJurisdiction([Jurisdiction.UK, Jurisdiction.DE, Jurisdiction.NL]) || autoplayModel.autoplayDisabled) {
                    rulesText.setText(translations.get("pays_game_rules_jurisdiction", {version: __VERSION__, rtp_total: rtp + ""}));
                } else if(settingsModel.socialSweepstakes && settingsModel.rtpdisplay === false) {
                    rulesText.setText(translations.get("pays_game_rules_nortp", {version: __VERSION__, rtp_total: rtp + ""}));
                } else {
                    rulesText.setText(translations.get("rm.bod", {version: __VERSION__, rtp_total: rtp + ""}));
                }
            }
        });

        const tConfig = Components.config.matrix.transition.options;
        const reelTransition = new G288SpinReelTransition(tConfig.startGap, tConfig.stopGap, tConfig.quickStopGap, tConfig.allowPartialSkips);
        Components.matrix.setTransition(reelTransition);

        let symbolBehaviours = Components.config.matrix.symbolBehaviours;
        if (symbolBehaviours) {
            for (const symbolBehaviour of symbolBehaviours) {
                for (const symbol of Components.matrix.getAllSymbols()) {
                    const behaviour = symbolBehaviour.id;
                    const filteredSymbols = symbolBehaviour.symbols;

                    let behaviourInstance = null;
                    if(behaviour == "low_high") {
                        behaviourInstance = new LowToHighSymbolBehaviour(symbol);                        
                    } else if(behaviour == "frameOverAnimate") {
                        behaviourInstance = new FrameOverSymbolBehaviour(symbol);
                    } else if(behaviour == "anticipate288") {
                        behaviourInstance = new AnticipateSymbolBehaviour(symbol);
                    }
                    if(behaviourInstance) {
                        behaviourInstance.validSymbols = filteredSymbols;
                        symbol.addBehaviour(behaviourInstance);
                        symbol.refresh();
                    }
                }
            }
        } 
        if(!deviceInfo.isDesktop) {
            const hideLogo = () => {
                const logo = Layers.MatrixForeground.getSprite("Logo_288");
                if(logo) {
                    if(canvasManager.orientation == Orientation.PORTRAIT) {
                        logo.visible = false;
                    } else {
                        logo.visible = true;
                    }
                }
            }
            canvasManager.onOrientationChange.add(hideLogo);
            hideLogo();
        }
    }

    protected startGame() {
        G288Components.init();
        super.startGame();
    }
}


// WEBPACK FOOTER //
// ./~/ifdef-loader/ifdef-loader.js??ref--0-1!./src/states/init.ts